// ── clear-series-result: HONEST cleared/detached render (FR-SESS-002) ───────
// Renders the Clear Series response as exactly what it is: how many FUTURE
// sessions were cleared, that past sessions were preserved, and that the
// invites/recordings/reports were KEPT-AND-DETACHED (never deleted — every
// …Deleted is false). A pure idempotent replay (same Idempotency-Key) is shown
// honestly as "no new sessions cleared" so a replay can never imply a fresh
// destructive effect. Nothing here is fabricated.

import { Alert } from "@vjal/ui";

import type { CoachingClearSeriesResponseDto } from "../../services/coaching-readiness-dtos";

export function ClearSeriesResult({ result }: { result: CoachingClearSeriesResponseDto | null }) {
  if (!result) return null;
  const { clear } = result;
  const cleared = clear.futureSessionsClearedCount;

  return (
    <Alert variant="success">
      <span className="font-semibold" data-testid="clear-series-cleared-count">
        {clear.idempotentReplay
          ? "No new future sessions were cleared (this series was already cleared)."
          : `${cleared} future session${cleared === 1 ? "" : "s"} cleared (as of ${clear.asOfDate}).`}
      </span>{" "}
      Past sessions were preserved. The invites ({clear.invitesDetachedCount}), recordings (
      {clear.recordingsDetachedCount}), and reports ({clear.reportsDetachedCount}) for those sessions were{" "}
      <span className="font-semibold">kept and detached</span> from the series — they still exist and were not
      deleted.
    </Alert>
  );
}
